module.exports = __webpack_public_path__ + "static/table2-efd1d4c274c2ffbe3d19302c67bb1674.jpg";